/*
 * Authors: mariushirjanu, Koen
 * Created: 01/02/2017
 * Upgraded: 09/01/2024
 */
import { IOrderSearchDetail, OrderSearchDataService } from '../../../shared/services/order/order-search-data.service';
import { urlUtil } from '../../../shared/util';
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { TicketGuideDialogService } from '../../../shared/services/ticket-guide/ticket-guide-dialog.service';

@Component({
  selector: 'order-search-result-detail',
  template: `
    <div class="search-result">
      <h4 *ngIf="loading">
        <activity-indicator toLoad="GA.GENERAL.DETAILS"></activity-indicator>
      </h4>
      <div *ngIf="orderDetail">
        <div class="row">
          <div class="col-md-9">
            <table class="table order-search-result-table">
              <tbody>
              <tr *ngFor="let wf of orderDetail.workflow; trackById" [ngClass]="{ current:wf.activeStep, future:!wf.stepState }">
                <td class="step-status"><i class="fa fa-arrow-right" *ngIf="wf.activeStep"></i></td>
                <td class="step-date">{{wf.date}}</td>
                <td class="step-info">
                  <i class="fa fa-info-circle info-icon" *ngIf="wf.comments" [popover]="wf.comments" [outsideClick]="true"></i>
                </td>
                <td class="step-desc">
                  <div *ngFor="let step of wf.steps; trackById">{{step}}</div>
                </td>
              </tr>
              <tr class="tracking-url">
                <td></td>
                <td translate>ORDERENTRY.SEARCH.TRACKING_URL</td>
                <td>
                  <div *ngFor="let trackingUrl of orderDetail.trackingUrl; trackById">
                    <a [href]="trackingUrl.url" *ngIf="trackingUrl.url" target="_blank">{{(trackingUrl.trackingNumber? trackingUrl.trackingNumber : trackingUrl.url)}}</a>
                    <span *ngIf="!trackingUrl.url">{{trackingUrl.trackingNumber}}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-3">
            <div class="float-end">
              <div class="bp-reference">BP# {{orderDetail.bpReference}}</div>
              <div class="vendor-reference">OEM# {{orderDetail.vendorReference}}</div>
            </div>
          </div>
        </div>
        <div class="more-info" *ngIf="!hideLinks">
          <a [href]="orderLink" target="_blank" translate>ORDERENTRY.SEARCH.MORE_INFO</a>
          <a href="" (click)="openSupportDialog($event, orderDetail.id)" translate>ORDERENTRY.SEARCH.SUPPORT</a>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./order-search-result-detail.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderSearchResultDetailComponent implements OnChanges {
  @Input() public orderId:string;
  @Input() public hideLinks:boolean;
  public orderLink:string;
  public loading:boolean;
  public orderDetail:IOrderSearchDetail;

  constructor(
    private orderSearchDataService:OrderSearchDataService,
    private ticketGuideDialogService:TicketGuideDialogService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.orderId) {
      this.orderId = changes.orderId.currentValue;
      this.orderLink = `/ga2/#/unacc?url=${urlUtil.encodeUri('/unacc/O_OrderView_Edit.jsp?row0_Dereqid=' + this.orderId + '&ejbEvent=edit')}`;
      this.loadOrder();
    }
    if (changes.hideLinks) {
      this.hideLinks = changes.hideLinks.currentValue;
    }
  }

  public openSupportDialog(event:Event, orderId:number):void {
    event.preventDefault();
    this.ticketGuideDialogService.openTicketGuideDialog({ orderId });
  }

  private loadOrder():void {
    if (this.orderId) {
      this.loading = true;
      this.orderSearchDataService.loadSearchDetail('order', this.orderId)
        .then((result:IOrderSearchDetail) => {
          this.orderDetail = result;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}